var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M66.6666 70V63.3333C66.6666 59.7971 65.2618 56.4057 62.7613 53.9052C60.2609 51.4048 56.8695 50 53.3332 50H26.6666C23.1304 50 19.739 51.4048 17.2385 53.9052C14.738 56.4057 13.3333 59.7971 13.3333 63.3333V70M53.3332 23.3333C53.3332 30.6971 47.3637 36.6667 39.9999 36.6667C32.6361 36.6667 26.6666 30.6971 26.6666 23.3333C26.6666 15.9695 32.6361 10 39.9999 10C47.3637 10 53.3332 15.9695 53.3332 23.3333Z",
    stroke: "#054757",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profile-image.40f95a7fbaa21d1e638c725e16abadda.svg";
export { ForwardRef as ReactComponent };